export default function handleError(error) {
    if (error.response) {
        if (error.response.status === 403) {
            return ' Phiên đăng nhập hết hạn. Vui lòng đăng nhập lại!';
        }
        if (error.response.status === 400 || error.response.status === 429) {
            return error.response?.data.msg;
            // return error.response.message
        }
        if(error.response.status === 422){
            return "Lỗi dữ liệu gửi lên"
        }

        if (error.response.status === 404) {
            return 'Không tìm thấy.';
            // return error.response.message
        }
        return 'Lỗi hệ thống. Vui lòng đăng nhập lại!';
    } else {
        // Something happened in setting up the request that triggered an Error
        return error.message || 'Lỗi hệ thống';
    }
}
